var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/List.tsx
import MuiList from "@mui/material/List";
import { jsx } from "react/jsx-runtime";
var List = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx(MuiList, __spreadProps(__spreadValues({}, rest), { children }));
};

// src/lib/ListItem.tsx
import MuiListItem from "@mui/material/ListItem";
import { forwardRef } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var ListItem = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx2(MuiListItem, __spreadProps(__spreadValues({}, props), { ref }));
});

// src/lib/ListItemAvatar.tsx
import MuiListItemAvatar from "@mui/material/ListItemAvatar";
import { jsx as jsx3 } from "react/jsx-runtime";
var ListItemAvatar = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx3(MuiListItemAvatar, __spreadProps(__spreadValues({}, rest), { children }));
};

// src/lib/ListItemButton.tsx
import MuiListItemButton from "@mui/material/ListItemButton";
import { forwardRef as forwardRef2 } from "react";
import { jsx as jsx4 } from "react/jsx-runtime";
var ListItemButton = forwardRef2((props, ref) => {
  return /* @__PURE__ */ jsx4(MuiListItemButton, __spreadProps(__spreadValues({}, props), { ref }));
});

// src/lib/ListItemIcon.tsx
import MuiListItemIcon from "@mui/material/ListItemIcon";
import { jsx as jsx5 } from "react/jsx-runtime";
var ListItemIcon = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx5(MuiListItemIcon, __spreadProps(__spreadValues({}, rest), { children }));
};

// src/lib/ListItemStatusCard.tsx
import { forwardRef as forwardRef3 } from "react";
import { styled, useThemeProps } from "@mui/material/styles";
import MuiListItem2 from "@mui/material/ListItem";
import { jsx as jsx6, jsxs } from "react/jsx-runtime";
var ListItemStatusCardSlot = styled(MuiListItem2, {
  name: "AvListItemStatusCard",
  slot: "root",
  overridesResolver: (props, styles) => [styles.root, props.color && styles.color]
})(({ theme, ownerState }) => __spreadValues({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "4px",
  marginBottom: "4px",
  paddingLeft: "8px",
  "&.MuiListItem-padding.MuiListItem-gutters": {
    paddingLeft: "calc(16px + 8px)"
  }
}, ownerState.color && ownerState.color !== "default" && {
  ".AvListItemStatusCard-statusAccent": {
    backgroundColor: `${theme.palette[ownerState.color].main}`
  }
}));
var StatusAccent = styled("div", {
  name: "AvListItemStatusCard",
  slot: "statusAccent",
  overridesResolver: (props, styles) => [styles.statusAccent, props.color && styles.color]
})(({ theme }) => ({
  position: "absolute",
  left: 0,
  top: 0,
  height: "100%",
  width: "8px",
  backgroundColor: theme.palette.divider,
  backgroundClip: "border-box",
  borderTopLeftRadius: "3px",
  borderBottomLeftRadius: "3px",
  content: "''"
}));
var ListItemStatusCard = forwardRef3((props, ref) => {
  const _a = props, { alignItems = "flex-start", children, color } = _a, rest = __objRest(_a, ["alignItems", "children", "color"]);
  const themeProps = useThemeProps({ props, name: "AvListItemStatusCard" });
  const ownerState = __spreadProps(__spreadValues({}, themeProps), { color });
  return /* @__PURE__ */ jsxs(ListItemStatusCardSlot, __spreadProps(__spreadValues({ alignItems, divider: false, ownerState }, rest), { ref, children: [
    /* @__PURE__ */ jsx6(StatusAccent, { className: "AvListItemStatusCard-statusAccent" }),
    children
  ] }));
});

// src/lib/ListItemText.tsx
import MuiListItemText from "@mui/material/ListItemText";
import { jsx as jsx7 } from "react/jsx-runtime";
var ListItemText = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx7(MuiListItemText, __spreadProps(__spreadValues({}, rest), { children }));
};

// src/lib/ListSubheader.tsx
import MuiListSubheader from "@mui/material/ListSubheader";
import { jsx as jsx8 } from "react/jsx-runtime";
var ListSubheader = (_a) => {
  var _b = _a, { children } = _b, rest = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx8(MuiListSubheader, __spreadProps(__spreadValues({}, rest), { children }));
};
export {
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon,
  ListItemStatusCard,
  ListItemText,
  ListSubheader
};
